// PeppermintClient
import { PeppermintClient } from './PeppermintClient';

export { PeppermintClient };

// SpeechRecognitionClient
import { SpeechRecognitionClient } from './SpeechRecognitionClient';

export { SpeechRecognitionClient };

// SpeechSynthesisClient
import { SpeechSynthesisClient } from './SpeechSynthesisClient';

export { SpeechSynthesisClient };

// VoiceCrossFrameWrapper
import { VoiceCrossFrameWrapper } from './VoiceCrossFrameWrapper';

export { VoiceCrossFrameWrapper };

// WakeWordClient
import { WakeWordClient } from './WakeWordClient';

export { WakeWordClient };

// VoiceExceptions
import {
    InvalidInputException,
    VoiceException,
    UnsupportedBrowserException,
    AudioException,
    InterruptedAudioException,
    HigherPriorityAudioPlayingException,
    VoiceDependencyFailureException,
    VoiceNotEnabledException,
    AudioRecordingException,
    RecordingAlreadyInProgressException,
    AudioProcessingException,
    SpeechRecognitionException,
    UnexpectedIntentException,
    RepeatIntentException,
    InvalidSpeechException,
    InvalidSpeechInputException,
    UnrecognizedSpeechException,
    StopIntentException,
    PauseIntentException,
    AlternativeBotException,
    WakeWordException,
    WakeWordValidUnknownActionException,
    WakeWordUnknownActionException,
    WakeWordInvalidActionException,
    WakeWordInitializationUnavailableException,
    WakeWordListeningUnavailableException,
    WakeWordDetectionFailureException,
    WakeWordUnknownErrorException,
    WakeWordListeningInterruptedException,
    WakeWordTimeoutException,
    ConfirmationDeclinedException,
} from '@services/voice/VoiceExceptions';

export {
    AlternativeBotException,
    AudioException,
    AudioProcessingException,
    AudioRecordingException,
    ConfirmationDeclinedException,
    HigherPriorityAudioPlayingException,
    InterruptedAudioException,
    InvalidInputException,
    InvalidSpeechException,
    InvalidSpeechInputException,
    PauseIntentException,
    RecordingAlreadyInProgressException,
    RepeatIntentException,
    SpeechRecognitionException,
    StopIntentException,
    UnexpectedIntentException,
    UnrecognizedSpeechException,
    UnsupportedBrowserException,
    VoiceDependencyFailureException,
    VoiceException,
    VoiceNotEnabledException,
    WakeWordDetectionFailureException,
    WakeWordException,
    WakeWordInitializationUnavailableException,
    WakeWordInvalidActionException,
    WakeWordListeningInterruptedException,
    WakeWordListeningUnavailableException,
    WakeWordTimeoutException,
    WakeWordUnknownActionException,
    WakeWordUnknownErrorException,
    WakeWordValidUnknownActionException,
};
